import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { axiosPost } from '../../../utils/axiosPost';
import { strapiUrl } from '../../../utils/constants';
import { devError } from '../../../utils/devLog';

const PDFDownloadButton = ({ committeeId, nominationCount }) => {
  const [isGenerating, setIsGenerating] = useState(false);
  const [downloadUrl, setDownloadUrl] = useState(null);

  const handleGenerate = async () => {
    setIsGenerating(true);
    try {
      const response = await axiosPost('committee-pdf/generate', {
        data: {
          sectionalCommitteeId: committeeId,
        },
      });
      if (response?.status === 200 && response.data?.url) {
        setDownloadUrl(response.data.url);
      }
    } catch (error) {
      devError('PDF generation error:', error);
      alert('Failed to generate PDFs. Please try again.');
    } finally {
      setIsGenerating(false);
    }
  };

  return (
    <div className="d-flex align-items-center">
      <small className="text-muted me-3">{nominationCount} nomination(s)</small>
      {downloadUrl ? (
        <a
          href={`${strapiUrl}${downloadUrl}`}
          download
          className="btn btn-success standard-width-button d-flex align-items-center gap-2 text-decoration-none"
        >
          <i className="bi bi-download" />
          Download PDFs
        </a>
      ) : (
        <button
          type="button"
          className="btn btn-primary standard-width-button d-flex align-items-center gap-2"
          onClick={handleGenerate}
          disabled={isGenerating}
        >
          <i
            className={`fas ${isGenerating ? 'fa-sync fa-spin' : 'fa-file-pdf'}`}
          />
          {isGenerating ? 'Generating...' : 'Generate PDFs'}
        </button>
      )}
    </div>
  );
};

PDFDownloadButton.propTypes = {
  committeeId: PropTypes.number.isRequired,
  nominationCount: PropTypes.number.isRequired,
};

export default PDFDownloadButton;
